import TextPopup from "@/popups/textPopup"
import { CustomWindowEvents } from "@/enums/customWindowEvents"

function getServicesText(): string {
	if (window.seasonManager.isWinter()) {
		return window.lihe.servicesWinter || window.lihe.services
	} else {
		return window.lihe.servicesSummer || window.lihe.services
	}
}

function getDescriptionText(): string {
	if (window.seasonManager.isWinter()) {
		return (
			window.lihe.generalDescriptionWinter || window.lihe.generalDescription
		)
	} else {
		return (
			window.lihe.generalDescriptionSummer || window.lihe.generalDescription
		)
	}
}

const initTextPopups = (): void => {
	// text popups
	const servicesShowMoreElement: HTMLDivElement | null = document.querySelector(
		"#services-show-more"
	)

	const descriptionPopupText: string = getDescriptionText()
	const descriptionPopup = new TextPopup(
		window.lihe.name,
		descriptionPopupText,
		"description-popup",
		"#description-show-more"
	)
	descriptionPopup.initTextPopup()
	window.descriptionPopup = descriptionPopup

	const servicesText: string = getServicesText()
	if (!servicesText && servicesShowMoreElement) {
		servicesShowMoreElement.style.display = "none"
	} else {
		const servicesPopup = new TextPopup(
			window.content.liheDesc_services,
			servicesText,
			"services-popup",
			"#services-show-more"
		)
		servicesPopup.initTextPopup()
		window.servicesPopup = servicesPopup
	}

	const transportPopUp = new TextPopup(
		"TRANSPORT",
		"s",
		"transport-popup",
		"#transport-show-more"
	)

	transportPopUp.initTextPopup()
	window.transportPopUp = transportPopUp
}

export default async () => {
	initTextPopups()

	window.addEventListener(CustomWindowEvents.CHANGE_SEASON, () => {
		initTextPopups()
	})
}
